import {makeRuleBundleNamespace} from '@frontapp/workflows/rules';
import {chain} from 'lodash';

import {ConversationTeamStatusesEnum} from '../../../libs/shared/core/src/models/api/conversationCommonTypes';
import {SlaRuleBundleInfo} from '../../../libs/shared/core/src/models/api/ruleBundleInfo';
import {ConversationBaseModel} from '../../models/api/conversationModel';

export function getEarliestSlaBreach(
  conversation: ConversationBaseModel,
  activeSlaRuleBundles: ReadonlyArray<SlaRuleBundleInfo>,
): number | undefined {
  const slaBundleBreach = getEarliestSlaBundle(conversation, activeSlaRuleBundles);
  if (!slaBundleBreach) {
    return undefined;
  }

  return getBreachTime(conversation, slaBundleBreach);
}

export function getEarliestSlaBundleBreach(
  conversation: ConversationBaseModel,
  activeSlaRuleBundles: ReadonlyArray<SlaRuleBundleInfo>,
) {
  const slaBundleBreach = getEarliestSlaBundle(conversation, activeSlaRuleBundles);
  if (!slaBundleBreach) {
    return undefined;
  }

  return {
    ...slaBundleBreach,
    breachTime: getBreachTime(conversation, slaBundleBreach),
  };
}

function getEarliestSlaBundle(
  conversation: ConversationBaseModel,
  activeSlaRuleBundles: ReadonlyArray<SlaRuleBundleInfo>,
) {
  // SLA Timers are only important when the conversation is ongoing.
  if (conversation.teamStatus !== ConversationTeamStatusesEnum.OPEN) {
    return undefined;
  }

  return (
    chain(activeSlaRuleBundles)
      // We only care about Rule Bundles that exist in the same namespace as the conversation.
      .filter((b) => b.namespace === conversation.namespace)
      .minBy((b) => getBreachTime(conversation, b))
      .value()
  );
}

function getBreachTime(conversation: ConversationBaseModel, bundle: SlaRuleBundleInfo) {
  return conversation.slaTimers[makeRuleBundleNamespace(bundle.id)]?.breach_time;
}
